// The Activity Log's flow line for one suggestion (2026-10-14, prod contact
// 7210364): which flow it matched, or that none did and why. From the
// server's modelMeta.flowMatch (services/flow-automation.js's
// describeFlowMatch()). An older suggestion without it falls back to its
// bare flow key, or nothing.
//   { matched: true }            -> "Flow: <display name> (<flow key>)"
//   a flow key, no catalog row   -> "No flow matched: <reason>"
//   no flow key                  -> "No flow matched: <reason>"
// An agent-drafted reply on a flow set to Automate (2026-10-21) adds the
// server's automationHold: "... · Agent draft: needs a person".
export function flowLine(suggestion) {
  const m = suggestion?.modelMeta?.flowMatch
  if (!m) return suggestion?.flowKey ? { matched: true, text: `Flow: ${suggestion.flowKey}` } : null
  if (m.matched && m.flowKey) {
    const base = m.displayName ? `Flow: ${m.displayName} (${m.flowKey})` : `Flow: ${m.flowKey}`
    return { matched: true, text: m.automationHold ? `${base} · ${m.automationHold}` : base, ...(m.automationHold ? { hold: m.automationHold } : {}) }
  }
  return { matched: false, text: `No flow matched: ${m.reason ?? 'no reason recorded'}` }
}
